import styled,{css} from "styled-components";
import '../../../styles/mediaWidth.scss'
const colorTable = {
  green: {
    background: "#98c256",
    hovered: "#73943f",
    text: "#fff"
  },
  blue: {
    background: "#7899c8",
    hovered: "#5c79a2",
    text: "#fff"
  },
  yellow: {
    background: "#fcec7f",
    hovered: "#d2c256",
    text: "#fff"
  },
  sky :{
    background: "#99c7ff",
    hovered : "#7ab6ff",
    text: "#fff"
  },
  purple : {
    background : "#6f6fe9",
    hovered : "#6262e9",
    text : "#fff"
  },
  emerald : {
    background : "#6fcccc",
    hovered : "#53cccc",
    text : "#fff"
  },
  black : {
    background : "#000000",
    hovered : "#3f3f3f",
    text : "#fff"
  },
  lightBlue :{
    background :"#6a9fdf",
    hovered : "#4f80bc",
    text : "#fff"
  },
  red :{
    background :"#a91c33",
    hovered : "#aa3d4f",
    text : "#fff"
  },
  orange : {
    background :"#f24f2f",
    hovered : "#de492c",
    text : "#fff"
  },
  darkGray : {
    background : "#424242",
    hovered : "#747474",
    text : "#fff"
  }
};

export const DesignedButtonWrapper = styled.div`
 
  /* width: 280px; */
  height: 46px;
  cursor: ${props => props.disabled? "default":"pointer"};
  margin : ${props => props.margin ? props.margin : "auto"};
  ${props => !props.disabled && css`
  &:hover > div {
    background-color: ${props => colorTable[props.color].hovered};
  }
  &:hover{
    img{
      left:${({left})=>(left?left:0) + 190}px;
    }
  }`}
`;

export const TextContainer = styled.div`
  position: relative; 
  width: ${props => props.width ? props.width : "227px"};
  height: 46px;
  background-color: ${props => colorTable[props.color].background};
  border-radius: 46px;
  transition: 0.3s;
  margin : auto;
  box-sizing :border-box;
  /* cursor : pointer; */
`;
export const Text = styled.p`
  line-height: 46px;
  color: ${props => colorTable[props.color].text};
  font-weight: 600;
  font-size: 16px;
  position: relative;
  img{
    display : ${props=> props.displayNone ? "none" : "unset"};
    position : absolute;
    top: calc(50% - 15px);
    left:${props=> props.left?props.left + 185: 185}px;
    width: 30px;
    transition: all .3s ease;
  }
`;

